export function extractProps(props, typeOrTypes) {
    const types = Array.isArray(typeOrTypes) ? typeOrTypes : [typeOrTypes];
    return Object.keys(props).reduce((acc, key) => {
        if (types.some(type => key === type || key.startsWith(`${type}-`))) {
            acc[key] = props[key];
        }
        return acc;
    }, {});
}
